module.exports = __webpack_public_path__ + "static/media/link.efab6a93.svg";